import Modal from "global/component/Genericos/Modal/Modal";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import ConsultaIcon from "_+_Portal/assets/images/generico/ConsultaIcon";
import CorazonIcon from "_+_Portal/assets/images/generico/CorazonIcon";
import LaboratorioIcon from "_+_Portal/assets/images/generico/LaboratorioIcon";
import TestPcrIcon from "_+_Portal/assets/images/generico/TestPcrIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BtnContainer,
  ContainerNecesitoTurno,
  TextNecesitoTurno,
} from "./localStyle";
import camelize from "global/utils/camelize";
import { useHistory } from "react-router";
const NecesitoTurno = () => {
  // -------------------------  context ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { modalState, authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------
  let parsedConfig = {};
  try {
    parsedConfig = JSON.parse(localStorage.getItem("config")) || {};
  } catch (e) {
    parsedConfig = {};
  }
  let opcAutoCheckInLabo = parsedConfig.opcAutoCheckInLabo;
  let opcAtencionSinTurnoPrevio = parsedConfig.opcAtencionSinTurnoPrevio;
  let opcConsultaMedica = parsedConfig.opcConsultaMedica;
  let opcEstudios = parsedConfig.opcEstudios;
  const pacienteNombre = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.nombre
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre;
  const history = useHistory();

  // -------------------------  constantes ----------------------------

  const handleOnclick = (path) => {
    if (path === "CONSULTA") {
      setPaso("TipoTurnoConsulta")(pasoDispatch);
    } else if (path === "ESTUDIO") {
      history.push("/estudios");
    } else if (path === "LABO") {
      history.push("/laboratorio");
    }
  };

  const atencionSinTurnoPrevio = () => {
    setPaso("AtencionSinTurnoSelect")(pasoDispatch);
  };

  return (
    <>
      {modalState.modal.show && <Modal />}
      <LayoutPasos
        title={"Necesito turno"}
        subtitle={camelize("Para: " + pacienteNombre)}
      >
        <ContainerNecesitoTurno
          initial={{ opacity: 0, y: +100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
        >
          <TextNecesitoTurno>
            <span className="title-saludo">
              <span className="title-negrita">¿Que turno estas buscando?</span>
            </span>
          </TextNecesitoTurno>
          <BtnContainer>
            {opcConsultaMedica && (
              <BtnLink
                Icon={<ConsultaIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"CONSULTA MÉDICA"}
                onclick={() => handleOnclick("CONSULTA")}
              />
            )}
            {opcEstudios && (
              <BtnLink
                Icon={<CorazonIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"ESTUDIO"}
                onclick={() => handleOnclick("ESTUDIO")}
              />
            )}
            {opcAutoCheckInLabo && (
              <BtnLink
                Icon={<TestPcrIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"LABORATORIO"}
                onclick={() => handleOnclick("LABO")}
              />
            )}
            {opcAtencionSinTurnoPrevio && (
              <BtnLink
                Icon={<LaboratorioIcon color={"var(--color-primary)"} />}
                title={"ATENCIÓN SIN TURNO PREVIO"}
                type="NORMAL"
                onclick={atencionSinTurnoPrevio}
              />
            )}
          </BtnContainer>
        </ContainerNecesitoTurno>
      </LayoutPasos>
    </>
  );
};

export default NecesitoTurno;
